<template>
    <div
        class="o-compass compass"
    >
        <svg-icon
            original
            name="icons/compass-off"
            class="compass__inner"
            :style="{'transform': 'rotate(' + value + 'deg)'}"
        />
    </div>
</template>

<script>

export default {
    name: 'OCompass',
    props: {
        value: {
            type: Number,
            default: 0
        }
    }
}
</script>

<style lang="scss">
@import "o-compass";   
</style>